import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=3526570a&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"
import style0 from "./Payment.vue?vue&type=style&index=0&id=3526570a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526570a",
  null
  
)

export default component.exports